import {
  patchState,
  signalStore,
  withHooks,
  withMethods,
  withState,
} from '@ngrx/signals';
import { BaseState, withCrudOperations } from '../crud.state';
import { withDataLayerTypeSelectors } from './data-layer-type.selectors';
import { DataLayerTypeService } from '../../services/data-layer-type/data-layer-type.service';
import { DataLayerType } from '../../models/data-layer-type';
import { withLogging } from '../features/logger.feature';
import { inject } from '@angular/core';
import { IconService } from '../../services/icon/icon.service';

export type DataLayerTypeState = BaseState<DataLayerType>;

export const initialState: DataLayerTypeState = {
  items: {},
  loading: false,
  selectedId: '',
  selection: [],
  initialized: false,
  itemsLoaded: false,
  version: 0,
  lastPersistedId: '',
  trigger: undefined,
  entityType: 'DataLayerType',
  entityLabel: 'Raum',
  filter: {
    query: '',
    category: [],
    tags: undefined,
    products: undefined,
    published: null,
    locked: null,
    ids: undefined,
  },
  events: {
    add: ['checkForInitialLayers'],
  },
};

export const DataLayerTypeStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withCrudOperations<DataLayerType>(DataLayerTypeService),
  withLogging(initialState.entityType),
  withDataLayerTypeSelectors(),
  withMethods(store => ({
    reduceStoreByAvailableLayers(ids: string[]) {
      const filteredItems = Object.entries(store.items()).reduce(
        (acc, [key, value]) => {
          if (ids.includes(key)) {
            acc[key] = value;
          }
          return acc;
        },
        {} as Record<string, DataLayerType>
      );

      patchState(store, { items: filteredItems });
    },
  })),
  withHooks({
    onInit(store) {
      store.loadAllItemsByPromise();
    },
    onDestroy() {
      console.log('on destroy');
    },
  })
);
